import {call, put, takeLatest, select} from "redux-saga/effects";
import {downloadPDF} from "../../service/downloadPDF";
import {
  storeTemplateControllers,
  storeTestSensors,
  storeTestTemplateList,
  storeNonTestTemplate,
  storeTemplates,
  storeCreateNonTestData,
  storeCreateTemplateData,
  storeReportSites,
  storeReportLocations,
  storeReportControllers,
  storeReports,
  storeCreateReportData,
  storeReportSelectedControllerList,
} from "../Actions/reports.actions";
import {
  getTemplateControllerAsync,
  requestTestSensorsAsync,
  createNonTestTemplateAsync,
  createTemplatesAsync,
  getNonTestTemplateAsync,
  deleteTemplatesAsync,
  getEachTemplateAsync,
  getReportSitesAsync,
  getReportLocationsAsync,
  getReportControllersAsync,
  getRecordAsync,
  createReportAsync,
  getReportsAsync,
  getEachReportAsync,
  changeReportStatusAsync,
  deleteReportAsync,
  getTemplateAsync,
  requestReportAnalysisAsync,
  requestReportPDFAsync,
} from "../AsyncActions/reports.async";
import {getNonTestTemplateList} from "../Selectors/reports.selectors";

import * as actions from "../action.constants";

function* requestTemplateController(action) {
  const {all = false} = action;

  try {
    const response = yield call(getTemplateControllerAsync, all);
    if (response?.data) {
      yield put(storeTemplateControllers(response.data.results));
    }
  } catch (e) {
    return e;
  }
}

function* requestTestSensors(action) {
  const {mac} = action;
  try {
    const response = yield call(requestTestSensorsAsync, mac);
    if (response?.data) {
      yield put(storeTestSensors(response.data.results));
    }
  } catch (e) {
    return e;
  }
}

function* requestNonTestTemplates(action = {}) {
  const {id} = action;
  try {
    const response = yield call(getNonTestTemplateAsync, id);
    if (response?.data) {
      yield put(storeCreateNonTestData(response.data));
    }
  } catch (e) {
    return e;
  }
}

function* createNonTestTemplate(action) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(createNonTestTemplateAsync, payload);
    if (response?.data) {
      yield callback();
      const template = {label: response.data.description, value: response.data.id};
      const nonTestTemplateList = yield select(getNonTestTemplateList);
      if (payload.id) {
        const filteredTemplateList = nonTestTemplateList.filter(
          (template) => template.value !== payload.id
        );
        yield put(storeNonTestTemplate([...filteredTemplateList, template]));
      } else {
        yield put(storeNonTestTemplate([...nonTestTemplateList, template]));
      }
    }
  } catch (e) {
    return e;
  }
}

function* requestTemplates() {
  try {
    const response = yield call(getTemplateAsync);
    if (response?.data) {
      yield put(storeTemplates(response.data));
    }
  } catch (e) {
    return e;
  }
}

function* requestEachTemplate(action = {}) {
  const {id} = action;
  try {
    const response = yield call(getEachTemplateAsync, id);
    if (response?.data) {
      yield put(storeCreateTemplateData(response.data));
      yield put(storeTestTemplateList(response.data.results));
      yield put(storeNonTestTemplate(response.data.manual_results));
    }
  } catch (e) {
    return e;
  }
}

function* createTemplate(action) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(createTemplatesAsync, payload);
    if (response) {
      yield callback();
    }
  } catch (e) {
    return e;
  }
}

function* deleteTemplate(action) {
  const {id, callback = () => {}} = action;
  try {
    const response = yield call(deleteTemplatesAsync, id);
    if (response) {
      callback();
      yield call(requestTemplates);
    }
  } catch (e) {
    return e;
  }
}

function* requestReportSites() {
  try {
    const response = yield call(getReportSitesAsync);
    if (response?.data) {
      yield put(storeReportSites(response.data.results));
    }
  } catch (e) {
    return e;
  }
}

function* requestReportLocations(action = {}) {
  const {site} = action;
  try {
    const response = yield call(getReportLocationsAsync, site);
    if (response?.data) {
      yield put(storeReportLocations(response.data.results));
    }
  } catch (e) {
    return e;
  }
}

function* requestReportControllers(action = {}) {
  const {location} = action;

  try {
    const response = yield call(getReportControllersAsync, location);
    if (response?.data) {
      yield put(storeReportControllers(response.data.results));
    }
  } catch (e) {
    return e;
  }
}

function* requestRecord(action = {}) {
  const {mac, callback = () => {}} = action;

  try {
    const response = yield call(getRecordAsync, mac);
    if (response?.data) {
      callback(response.data.results);
    }
  } catch (e) {
    return e;
  }
}

function* reportCreation(action) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(createReportAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* reportsRequest(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getReportsAsync, pageUrl);
    if (response) {
      yield put(storeReports(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* reportDelete(action) {
  const {id, callback = () => {}} = action;

  try {
    const response = yield call(deleteReportAsync, id);
    if (response) {
      callback();
      yield call(reportsRequest, {pageUrl: ""});
    }
  } catch (e) {
    return e;
  }
}

function* requestEachReport(action = {}) {
  const {id} = action;

  try {
    const response = yield call(getEachReportAsync, id);
    if (response?.data?.data) {
      const {name, site, location, inventories, status} = response.data.data;
      yield put(
        storeCreateReportData({
          id,
          name,
          status,
          site,
          location,
          controller: {value: inventories[0]?.mac},
        })
      );
      yield put(storeReportSelectedControllerList(inventories));
    }
  } catch (e) {
    return e;
  }
}

function* changeReportStatus(action) {
  const {id, status = "", callback = () => {}} = action;

  try {
    const response = yield call(changeReportStatusAsync, id, status);
    if (response?.data) {
      if (status === "submitted") {
        callback();
      } else {
        yield call(requestEachReport, {id});
      }
    }
  } catch (e) {
    return e;
  }
}

function* requestReportAnalysis(action) {
  const {id, callback = () => {}} = action;

  try {
    const response = yield call(requestReportAnalysisAsync, id);
    if (response?.data) {
      callback(response.data.data);
    }
  } catch (e) {
    return e;
  }
}

function* requestReportPDF(action) {
  const {id} = action;

  try {
    const response = yield call(requestReportPDFAsync, id);
    if (response?.data) {
      downloadPDF(response.data.data?.url);
    }
  } catch (e) {
    return e;
  }
}

export function* reportsSaga() {
  yield takeLatest(actions.REQUEST_TEMPLATE_CONTROLLERS, requestTemplateController);
  yield takeLatest(actions.REQUEST_TEST_SENSORS, requestTestSensors);
  yield takeLatest(actions.REQUEST_NON_TEST_TEMPLATE, requestNonTestTemplates);
  yield takeLatest(actions.CREATE_NON_TEST_TEMPLATE, createNonTestTemplate);
  yield takeLatest(actions.REQUEST_TEMPLATES, requestTemplates);
  yield takeLatest(actions.REQUEST_EACH_TEMPLATE, requestEachTemplate);
  yield takeLatest(actions.CREATE_TEMPLATE, createTemplate);
  yield takeLatest(actions.DELETE_TEMPLATE, deleteTemplate);
  yield takeLatest(actions.REQUEST_REPORTS_SITES, requestReportSites);
  yield takeLatest(actions.REQUEST_REPORTS_LOCATIONS, requestReportLocations);
  yield takeLatest(actions.REQUEST_REPORT_CONTROLLERS, requestReportControllers);
  yield takeLatest(actions.REQUEST_RECORD, requestRecord);
  yield takeLatest(actions.REQUEST_CREATE_REPORT, reportCreation);
  yield takeLatest(actions.REQUEST_REPORTS_SAGA, reportsRequest);
  yield takeLatest(actions.REQUEST_EACH_REPORT, requestEachReport);
  yield takeLatest(actions.CHANGE_REPORT_STATUS, changeReportStatus);
  yield takeLatest(actions.REQUEST_REPORT_ANALYSIS, requestReportAnalysis);
  yield takeLatest(actions.REQUEST_REPORT_PDF, requestReportPDF);
  yield takeLatest(actions.DELETE_REPORT, reportDelete);
}
